import { Injectable } from '@angular/core';
import { Observable, combineLatest, BehaviorSubject } from 'rxjs';

import { ChatDispatchers } from 'src/app/store/chats/chat.dispatchers';
import { RootStoreSelectors } from 'src/app/store/root-store.selectors';
import { EventUiDispatchers } from 'src/app/store/eventsUI/eventUI.dispatchers';

import { IChat } from 'src/models/IChat';
import { EventUI } from 'src/models/EventUI';
import { ISelectedFiles } from 'src/models/ISelectedFiles';
import { UPDATE_EVENT_REF } from 'src/models/constants';

@Injectable({ providedIn: 'root' })
export class EventsService {
  confoirmDeleteWindow = false;
  selectedEvant: IChat;

  public _currentPhotoUploaded = new BehaviorSubject<any>({});
  public currentPhotoUploaded$ = this._currentPhotoUploaded.asObservable();

  constructor(
    private _selectors: RootStoreSelectors,
    private _chatDispatchers: ChatDispatchers,
    private _eventUiDispatchers: EventUiDispatchers
  ) {}

  createEvent(event: IChat): void {
    this._chatDispatchers.createEvent(event);
  }

  resetPaging() {
    this._eventUiDispatchers.resetEventPaging();
  }

  viewEvent(event: IChat): void {
    this.getChatAdministrators(event.id);
    this._eventUiDispatchers.viewEventUI(event);
  }

  closeViewEvent(): void {
    this._eventUiDispatchers.closeViewEventUI();
  }

  showEditEventScreen(event: IChat): void {
    const photo = {
      file: null,
      url: event.localThumbnail
    };
    this._currentPhotoUploaded.next(photo);
    this.getChatAdministrators(event.id);
    this._eventUiDispatchers.editEventUI(event);
  }

  showCreateEventScreen() {
    this._eventUiDispatchers.createEventUI();
  }

  closeEditEventScreen(): void {
    this._eventUiDispatchers.closeEventEditUI();
  }

  uploadEventImage(file): void {
    this._eventUiDispatchers.uploadEventImage(file);
  }

  eventCreationComplete(): void {
    this._eventUiDispatchers.eventCreationComplete();
  }

  updateEvent(chatID: string, updatedEventProps: IChat) {
    updatedEventProps.id = chatID;
    this._chatDispatchers.updateChat(updatedEventProps, UPDATE_EVENT_REF);
  }

  updateStore(chatID: string, updatedEventProps: IChat) {
    updatedEventProps.id = chatID;
    this._chatDispatchers.updateStore(updatedEventProps, UPDATE_EVENT_REF);
    this._eventUiDispatchers.closeEventEditUI();
  }

  confirmDelete(id: string) {
    this.deleteEvent(id);
    this.toggleConfirmDeleteWindow(false);
  }

  deleteEvent(id: string) {
    this._chatDispatchers.deleteChat(id);
  }

  toggleConfirmDeleteWindow(e: boolean, evant?: IChat) {
    this.confoirmDeleteWindow = e;
    this.selectedEvant = evant;
  }

  getNextPage(): void {
    this._eventUiDispatchers.getNextEventPage();
  }

  getPreviousPage(): void {
    this._eventUiDispatchers.getPrevEventPage();
  }

  get eventUiState$(): Observable<EventUI> {
    return this._selectors.eventUiState$;
  }

  get eventList$(): Observable<IChat[]> {
    return this._selectors.getEventList$();
  }

  get selectedEvent$(): Observable<IChat> {
    return this._selectors.getSelectedEvent$();
  }

  get eventInCreationProcess$(): Observable<IChat> {
    return this._selectors.getEventInCreationProcess$();
  }

  get componentContext$() {
    return combineLatest([
      this.eventUiState$,
      this.eventList$,
      this.selectedEvent$,
      this.eventInCreationProcess$
    ]);
  }

  getChatAdministrators(id: string) {
    this._chatDispatchers.getChatAdministrators(id);
  }

  updateEventPhoto(chat: IChat) {
    this._chatDispatchers.updateChat(chat);
  }
}
